import { useEffect } from "react";
import { api } from "@/lib/trpc";
import { clearHawkUser, setHawkUser } from "./hawk";

/** Привязывает Hawk к `users.id` текущей сессии. Без сессии — отвязывает. */
export function HawkUserBinder() {
	const me = api.auth.me.useQuery(undefined, { retry: false });

	useEffect(() => {
		if (me.data?.userId) setHawkUser(me.data.userId);
		else clearHawkUser();
	}, [me.data?.userId]);

	return null;
}
